import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { updatecurrentPlanIndex } from "../../services/MilestoneService";
import { getProfile } from "../../services/PersonalService";
import { RootStoreContext } from "./../../store";
import { planList } from "./constant";
import {
  Action,
  ActionContainer,
  ActivityButton,
  Card,
  Container,
  Description,
  Gap,
  ProgressBar,
  ProgressBarContainer,
  ProgressContainer,
  ProgressText,
  SmallText,
  StartButton,
  Step,
  Title,
  TopicTitle,
  YellowText,
} from "./style";
import "./style.css";

const Milestone = () => {
  const { MilestoneStore, MilestoneDetailStore, LoginStore } =
    useContext(RootStoreContext);
  const { getProgress, progressList, init } = MilestoneDetailStore;
  const { currentPlanIndex, updateData, getcurChapter } = MilestoneStore;
  const { user } = LoginStore;
  const history = useHistory();
  const { index } = useParams();
  const { PersonalStore } = useContext(RootStoreContext);
  useEffect(() => {
    getProfile()
      .then((value) => {
        PersonalStore.updateData("username", value.username);
        PersonalStore.updateData("profile_picture", value.profile_picture);
      })
      .catch(console.log);
  }, []);

  useEffect(() => {
    getProgress(user.uid);
    // updateData("currentPlanIndex", index);
  }, []);

  const progress = (index) => {
    let result = 0;
    if (progressList.length) {
      if (progressList[index]) {
        if (progressList[index].docUrl) {
          result++;
        }
        if (progressList[index].task) {
          result++;
        }
        if (progressList[index].companyUrl) {
          result++;
        }
      }
      return ((result / (index === 10 ? 3 : 2)) * 100).toFixed(0);
    }
  };
  const [curChapter, setcurChapter] = useState(currentPlanIndex);
  useEffect(() => {
    if (progress(curChapter) == 100 || curChapter == 1) {
      setcurChapter(curChapter + 1);
      updateData("currentPlanIndex", curChapter + 1);
      updatecurrentPlanIndex(curChapter + 1);
    }
  }, [progress(curChapter), currentPlanIndex]);

  return (
    <div>
      <Container>
        <Step>
          <YellowText>STEP 1</YellowText>
          <Gap />
          <SmallText>創業沙盤歷程</SmallText>
        </Step>
        <Title>我的商業計畫</Title>
        {planList.map(
          (
            {
              title,
              subtitle,
              chapterActivity,
              menutitle,
              referList,
              surveylink,
            },
            index
          ) => {
            if (index <= currentPlanIndex) {
              return (
                <Card key={`Card-${index}`}>
                  <div>
                    <TopicTitle>{title}</TopicTitle>
                    <Description>{subtitle}</Description>
                  </div>
                  <Action>
                    {!surveylink && !!progressList.length > 0 && (
                      <ProgressContainer>
                        <ProgressBarContainer>
                          <ProgressBar progress={progress(index)}></ProgressBar>
                        </ProgressBarContainer>
                        <ProgressText>{progress(index)}% 完成度</ProgressText>
                      </ProgressContainer>
                    )}
                    {chapterActivity && (
                      <ActionContainer>
                        <div onClick={() => history.push(`/${menutitle}`)}>
                          <ActivityButton>章節互動</ActivityButton>
                        </div>
                      </ActionContainer>
                    )}
                    {referList && (
                      <ActionContainer>
                        <Link
                          to={
                            index === 11
                              ? `WebMaking`
                              : `/Milestone/MilestoneDetail/${index}`
                          }
                        >
                          <StartButton>開始你的計畫</StartButton>
                        </Link>
                        {/* <EditText>5 人已編輯</EditText> */}
                      </ActionContainer>
                    )}
                    {surveylink && (
                      <ActionContainer>
                        <a href={surveylink} target="_blank" rel="noreferrer">
                          <StartButton>填寫表單</StartButton>
                        </a>
                      </ActionContainer>
                    )}
                  </Action>
                </Card>
              );
            }
            return;
          }
        )}
      </Container>
    </div>
  );
};

export default observer(Milestone);
